import axios from 'axios';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import React, { useContext, useState, useEffect, useCallback } from 'react';

import { formatDate } from '../../utils/moment.util';
import { AppDispatchContext, AppStateContext } from '../../contexts/AppContext';

import './style.css';

const BlogSidebar = () => {
  const [tags, setTags] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const { dispatch } = useContext(AppDispatchContext);
  const { state } = useContext(AppStateContext);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchPosts = (query) => {
    axios
      .get(`${baseUrl}/blog?searchQuery=${query}`)
      .then((res) => {
        const {
          totalPages,
          page,
          hasPrevPage,
          hasNextPage,
          nextPage,
          prevPage,
        } = res.data.data;

        dispatch({
          type: 'SET-PAGINATION',
          payload: {
            totalPages,
            hasPrevPage,
            hasNextPage,
            nextPage,
            prevPage,
            currentPage: page,
          },
        });

        dispatch({
          type: 'SET-POSTS',
          payload: res.data.data.docs,
        });

        dispatch({
          type: 'SET-LOADING-POSTS',
          payload: false,
        });

        window.scrollTo({ top: 400, behavior: 'smooth' });
      })
      .catch((err) => {
        dispatch({
          type: 'SET-LOADING-POSTS',
          payload: false,
        });

        if (err.response && err.response.status === 404) {
          toast.info(
            `Posts matching, ${searchQuery
              .slice(0, 15)
              .toUpperCase()}... not found`
          );
        } else {
          toast.error(
            'Could not perform search operation. Try again or check back later.'
          );
        }
      });
  };

  const handleChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleTagClick = (tag) => {
    fetchPosts(tag);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (searchQuery) {
      fetchPosts(searchQuery);
    }
  };

  const filterTags = useCallback(() => {
    if (state.posts.length) {
      let filteredTags = [];
      const filteredPosts = state.posts.filter((post) => {
        if (post.tags.length) {
          return post.tags;
        }

        return post;
      });

      if (filteredPosts.length) {
        filteredTags = filteredPosts.map((post) => {
          return post.tags;
        });
      }

      if (filteredTags.length) {
        setTags(filteredTags);
      }
    }
  }, [state.posts]);

  useEffect(() => {
    filterTags();
  }, [filterTags]);

  return (
    <div className="col col-lg-4 col-12">
      <div className="wpo-blog-sidebar">
        {/* SEARCH SECTION */}
        <div className="widget search-widget">
          <h3>Search Here</h3>
          <form onSubmit={handleSubmit}>
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Post.."
                onChange={handleChange}
              />
              <button type="submit">
                <i className="ti-search"></i>
              </button>
            </div>
          </form>
        </div>

        {/* RECENT POSTS SECTION */}
        {state.posts.length ? (
          <div className="widget recent-post-widget">
            <h3>Recent posts</h3>
            <div className="posts">
              {state.posts.slice(0, 3).map((post) => (
                <div className="post" key={post._id}>
                  <div className="img-holder">
                    <img src={post.image} alt="" />
                  </div>
                  <div className="details">
                    <h4>
                      <Link to={`/blog-details/${post.slug}`}>
                        {post.title}
                      </Link>
                    </h4>
                    <span className="date">
                      {formatDate(post.createdAt, 'MMM DD, YYYY')}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}

        {/* TAGS SECTION */}
        {tags.length ? (
          <div className="widget tag-widget">
            <h3>Tags</h3>
            <ul>
              {tags.slice(0, 8).map((tag, index) => (
                <li
                  key={index}
                  className="text-capitalize"
                  onClick={() => handleTagClick(tag)}
                >
                  <Link to="/blog">{tag}</Link>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BlogSidebar;
